///include /assets/js/app/p/checkout.js
class CheckoutPayfast extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }
}

CheckoutDriver.byName.payfast = CheckoutPayfast
